var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadAssetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6667 34.6665V26.6665M31.6667 26.6665L35 29.9998M31.6667 26.6665L28.3333 29.9998",
    stroke: "#131619",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 33.3332H13.6667C12.1939 33.3332 11 32.1393 11 30.6665V17.3332C11 15.8604 12.1939 14.6665 13.6667 14.6665H19.7811C20.1347 14.6665 20.4739 14.807 20.7239 15.057L23 17.3332H32.3333C33.8061 17.3332 35 18.5271 35 19.9998V22.6665",
    stroke: "#131619",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAssetIcon);
export default __webpack_public_path__ + "static/media/uploadAssetIcon.bb9fa00f012828fef81085fe5e554901.svg";
export { ForwardRef as ReactComponent };